module.exports = __webpack_public_path__ + "img/shuaxin.745736f6.png";